import { ActorProfile } from '@mews-commander/data-access';

export interface WithCreatorProfileId {
    creatorProfileId: string;
}
export interface WithUpdaterProfileId {
    updaterProfileId: string;
}

export const createActorProfilesMapper =
    (profiles?: Array<ActorProfile> | null) =>
    <T extends WithCreatorProfileId & WithUpdaterProfileId>(data: T) => ({
        ...data,
        creatorProfile: profiles?.find((profile) => profile.id === data.creatorProfileId),
        updaterProfile: profiles?.find((profile) => profile.id === data.updaterProfileId),
    });

export type WithActorProfiles = Pick<
    ReturnType<ReturnType<typeof createActorProfilesMapper>>,
    'creatorProfile' | 'updaterProfile'
>;
